import { render, staticRenderFns } from "./LeftAdvertiser.vue?vue&type=template&id=50013130"
import script from "./LeftAdvertiser.vue?vue&type=script&lang=js"
export * from "./LeftAdvertiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports